import Typography from '@mui/material/Typography';
import { CompanyOnboardingStepKey } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { OnboardingCard, SettingsPageLink } from '../CompanyOnboardingPrimitives';

interface StepLinkOutCardProps {
  settingsLink: string;
  stepKey: CompanyOnboardingStepKey;
}

const StepLinkOutCard = ({ settingsLink, stepKey }: StepLinkOutCardProps) => (
  <OnboardingCard data-test-id="company-onboarding-link-out" sx={{ p: 2 }}>
    <Typography>{t(`company_onboarding.modules.${stepKey}.work_area_body`)}</Typography>
    <SettingsPageLink settingsLink={settingsLink}>
      {t('company_onboarding.actions.open_settings_page')}
    </SettingsPageLink>
  </OnboardingCard>
);

export default StepLinkOutCard;
